// extracted by mini-css-extract-plugin
export default {"wizardPageContainer":"Wizard_wizardPageContainer__QyYs+","dogStepsContainer":"Wizard_dogStepsContainer__RXJbP","nextStepButtonContainer":"Wizard_nextStepButtonContainer__NN39A"};